import { render } from "./ChatRecord.vue?vue&type=template&id=a4e2f44a&scoped=true"
import script from "./ChatRecord.vue?vue&type=script&lang=ts"
export * from "./ChatRecord.vue?vue&type=script&lang=ts"

import "./ChatRecord.vue?vue&type=style&index=0&id=a4e2f44a&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-a4e2f44a"

export default script